export enum MaccsBoxTicketStatus {
  Included = 0,
  ExcludedLineRefunded = 1,
  ExcludedNoScreenNumber = 2,
  ExcludedCinevilleNoVisit = 3,
  ExcludedScannedNoUsedVoucher = 4,
  ExcludedDistributorCodeMissing = 5,
  ExcludedMovieGlobalIdMissing = 6,
  ExcludedCinevillePriceMissing = 7,
  ExcludedReservationCancelled = 8,
  ExcludedReservationRefunded = 9,
}

export const maccsBoxTicketStatusTranslations: Record<MaccsBoxTicketStatus, string> = {
  [MaccsBoxTicketStatus.Included]: 'maccsbox_reports.tickets.status.included',
  [MaccsBoxTicketStatus.ExcludedLineRefunded]: 'maccsbox_reports.tickets.exclusion.line_refunded',
  [MaccsBoxTicketStatus.ExcludedNoScreenNumber]: 'maccsbox_reports.tickets.exclusion.no_screen_number',
  [MaccsBoxTicketStatus.ExcludedCinevilleNoVisit]: 'maccsbox_reports.tickets.exclusion.cineville_no_visit',
  [MaccsBoxTicketStatus.ExcludedScannedNoUsedVoucher]: 'maccsbox_reports.tickets.exclusion.scanned_no_used_voucher',
  [MaccsBoxTicketStatus.ExcludedDistributorCodeMissing]: 'maccsbox_reports.tickets.exclusion.distributor_code_missing',
  [MaccsBoxTicketStatus.ExcludedMovieGlobalIdMissing]: 'maccsbox_reports.tickets.exclusion.movie_global_id_missing',
  [MaccsBoxTicketStatus.ExcludedCinevillePriceMissing]: 'maccsbox_reports.tickets.exclusion.cineville_price_missing',
  [MaccsBoxTicketStatus.ExcludedReservationCancelled]: 'maccsbox_reports.tickets.exclusion.reservation_cancelled',
  [MaccsBoxTicketStatus.ExcludedReservationRefunded]: 'maccsbox_reports.tickets.exclusion.reservation_refunded',
};
